import { render, staticRenderFns } from "./update-db.vue?vue&type=template&id=4888f663&scoped=true&"
import script from "./update-db.vue?vue&type=script&lang=js&"
export * from "./update-db.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888f663",
  null
  
)

/* custom blocks */
import block0 from "./update-db.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports